import classNames from 'classnames'
import HeaderMain from '../../components/header-main/HeaderMain'
import ReportsCalendar from './reports-calendar/ReportsCalendar'
import ReportsFilter from './reports-filter/ReportsFilter'
import ReportsResult from './reports-result/ReportsResult'
import styles from './Reports.module.css'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchReports } from '../../redux/reducers/reports'
import { AppDispatch } from '../../redux/store'
import {
  fetchCars,
  // fetchCarsForAdmins
} from '../../redux/reducers/cars'
import { fetchUsers } from '../../redux/reducers/users'
import { reportFilterSelector } from '../../redux/selectors/report-filter-selector'
import ReportsCalendarCommon from './reports-calendar-common/ReportsCalendarCommon'
import { reportsCommonSelector } from '../../redux/selectors/reports-common-selector'
import {
  fetchReportsCommon,
  setSelectedReportsTab,
} from '../../redux/reducers/reports-common'
import { fetchClients } from '../../redux/reducers/clients'
import { getRole } from '../../utils/getRole'

function Reports() {
  const dispatch = useDispatch<AppDispatch>()
  const { isDriver } = getRole()
  const {
    calendarRange,
    calendarRangeCommon,
    selectedTrucks,
    selectedDrivers,
    selectedStatus,
    selectedUsersCommon,
    selectedStatusCommon,
  } = useSelector(reportFilterSelector)

  // this filter need for sort reports (now don't working)
  const [orderBy, setOrderBy] = useState('id')
  const [orderDirection, setOrderDirection] = useState('desc')

  const getCars = selectedTrucks?.map((item) => item.id)

  const getEmployees = selectedDrivers?.map((item) => item.id)

  const [isVisibleForm, setIsVisibleForm] = useState(true)
  const [isVisibleFormCommon, setIsVisibleFormCommon] = useState(true)

  useEffect(() => {
    dispatch(fetchCars())
    dispatch(fetchClients())
    dispatch(fetchUsers())
  }, [])

  const getReports = () => {
    dispatch(
      fetchReports({
        cars: getCars,
        employees: getEmployees,
        dateFrom: calendarRange[0].startDate,
        dateTo: calendarRange[0].endDate,
        status: selectedStatus,
        orderBy,
        orderDirection,
      })
    )
  }

  const getReportsCommon = () => {
    if (isDriver) return
    dispatch(
      fetchReportsCommon({
        dateFrom: calendarRangeCommon[0].startDate,
        dateTo: calendarRangeCommon[0].endDate,
      })
    )
  }

  useEffect(() => {
    dispatch(
      fetchReports({
        dateFrom: calendarRange[0].startDate,
        dateTo: calendarRange[0].endDate,
        cars: getCars,
        employees: getEmployees,
        status: selectedStatus,
      })
    )
  }, [calendarRange])

  useEffect(() => {
    if (isDriver) return
    dispatch(
      fetchReportsCommon({
        dateFrom: calendarRangeCommon[0].startDate,
        dateTo: calendarRangeCommon[0].endDate,
      })
    )
  }, [calendarRangeCommon, dispatch, isDriver])

  useEffect(() => {
    if (!isDriver) return
    dispatch(setSelectedReportsTab('1'))
  }, [dispatch, isDriver])

  const { currentReportTab } = useSelector(reportsCommonSelector)

  return (
    <div className={styles.accountContainer}>
      <div className={styles.accountWideContent}>
        <div className={styles.accountWideContentContainer}>
          <HeaderMain />

          {currentReportTab === '1' ? (
            <div className="row" style={{ justifyContent: 'space-evenly' }}>
              <ReportsCalendar
                calendarRange={calendarRange}
                isVisibleForm={isVisibleForm}
                setIsVisibleForm={setIsVisibleForm}
              />
              <div
                className={classNames(
                  'col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 account-right-col',
                  styles.accountRightCol
                )}
              >
                <ReportsFilter
                  selectedTrucks={selectedTrucks}
                  selectedDrivers={selectedDrivers}
                  selectedStatus={selectedStatus}
                  getReports={getReports}
                  isVisibleForm={isVisibleForm}
                />
                <ReportsResult
                  dateFrom={calendarRange[0].startDate}
                  dateTo={calendarRange[0].endDate}
                  getCars={getCars}
                  getEmployees={getEmployees}
                  isFiltersVisible={!isVisibleForm}
                />
              </div>
            </div>
          ) : (
            <ReportsCalendarCommon
              calendarRangeCommon={calendarRangeCommon}
              isVisibleForm={isVisibleFormCommon}
              setIsVisibleForm={setIsVisibleFormCommon}
              getReportsCommon={getReportsCommon}
              selectedUsersCommon={selectedUsersCommon}
              selectedStatusCommon={selectedStatusCommon}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Reports
